import { Pipe, PipeTransform } from '@angular/core';
import { ZoneIdType } from '../enum/zones-id.type.enum';

@Pipe({
  name: 'distanceUnit'
})
export class DistanceUnitPipe implements PipeTransform {
  transform(value: number | string, zoneId?: string): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const num = typeof value === 'string' ? Number(value) : value;

    if (zoneId === ZoneIdType.LONDON || zoneId === ZoneIdType.OUT_OPERATIVE_UK_AREA) {
      return `${(num * 0.621371).toFixed(2)} miles`;
    }

    return `${num} km`;
  }
}
